import AlBandarRotana from "../assets/images/Al-Bandar-Rotana.webp";
import AlHabtoor from "../assets/images/Al-Habtoor-Grand-Resort.webp";
import RegencyLuxury from "../assets/images/Regency-Luxury-Suites.webp";
import FortunePearl from "../assets/images/Fortune-Pearl-Hotel-Deira.jpg";
import FortuneGrand from "../assets/images/Fortune-Grand-Hotel-Deira.webp";
import OmegaHotel from "../assets/images/Omega-Hotel-Bur-Dubai.jpg";
import "../assets/css/custom-style.css";



export default function Partners() {
    const partners = [
        {
            name: "Al Bandar Rotana",
            image: AlBandarRotana,
        },
        {
            name: "Al Habtoor Grand Resort",
            image: AlHabtoor,
        },
        {
            name: "Regency Luxury Suites",
            image: RegencyLuxury,
        },
        {
            name: "Fortune Pearl Hotel",
            image: FortunePearl,
        },
        {
            name: "Fortune Grand Hotel",
            image: FortuneGrand,
        },
        {
            name: "Omega Hotel Bur Dubai",
            image: OmegaHotel,
        },
    ];

    return (
        <section className="py-24 bg-gradient-to-b from-blue-50 to-white dark:from-gray-900 dark:to-gray-950 overflow-hidden">
            <div className="container mx-auto px-6">

                {/* Header */}
                <div className="text-center mb-16">

                    <span className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-600 text-sm font-semibold mb-4">
                        Trusted Partners
                    </span>

                    <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                        Our Hotel Partners
                    </h2>

                    <p className="max-w-2xl mx-auto text-gray-600 dark:text-gray-400">
                        Collaborating with premium hotels and resorts across the UAE
                        to provide unforgettable stays and exclusive discounts.
                    </p>

                </div>

                {/* Infinite Slider */}
                <div className="relative overflow-hidden">

                    <div className="partner-slider flex gap-6">

                        {[...partners, ...partners].map((partner, index) => (
                            <div
                                key={index}
                                className="min-w-[200px] group relative overflow-hidden rounded-2xl shadow-lg h-[160px] flex-shrink-0"
                            >
                                <img
                                    src={partner.image}
                                    alt={partner.name}
                                    className="w-full h-full object-cover transition duration-700 group-hover:scale-110"
                                />

                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                                <div className="absolute bottom-0 left-0 right-0 p-6">
                                    <h3 className="text-white text-base md:text-lg font-semibold">
                                        {partner.name}
                                    </h3>

                                    <div className="w-12 h-1 rounded-full bg-cyan-400"></div>
                                </div>
                            </div>
                        ))}

                    </div>

                </div>

                {/* Stats Banner */}
                <div className="mt-20">

                    <div className="bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700 rounded-3xl p-10 text-white">

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">

                            <div>
                                <h3 className="text-4xl font-bold mb-2">
                                    100+
                                </h3>
                                <p>Partner Hotels</p>
                            </div>

                            <div>
                                <h3 className="text-4xl font-bold mb-2">
                                    10K+
                                </h3>
                                <p>Bookings Completed</p>
                            </div>

                            <div>
                                <h3 className="text-4xl font-bold mb-2">
                                    4.9★
                                </h3>
                                <p>Customer Rating</p>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </section>
    );
}